import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label
} from "reactstrap";
import { useHistory } from "react-router-dom";
import CustomPagination from "../../Components/Common/CustomPagination";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import ServerDetailsModal from "./ServerDetailModal";
import AssignTrainingsModal from "./AssignTrainingModal";
import Loader from "../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import QRCode from "react-qr-code";

const ServerManagement = () => {
    const history = useHistory();
    const [servers, setServers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addServerOpen, setAddServerOpen] = useState(false);
    const [accessCode, setAccessCode] = useState("");
    const [selectedServer, setSelectedServer] = useState(null);
    const [showServerModal, setShowServerModal] = useState(false);
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [serverToDelete, setServerToDelete] = useState(null);
    const [serverForm, setServerForm] = useState({
      first_name: "",
      last_name: "",
      username: "",
      access_code: ""
    });
    const [statusFilter, setStatusFilter] = useState("Active");
    const [showBulkCredModal, setShowBulkCredModal] = useState(false);
    const [bulkLoading, setBulkLoading] = useState(false);

    const [saving, setSaving] = useState(false);
    const [showQrModal, setShowQrModal] = useState(false);


    const openServerDetails = (server) => {
      console.log(server);
      
      setSelectedServer({
        ...server,
        copied_password: Number(server.copied_password) || 0
      });
      setShowServerModal(true);
    };

    const openAssignTrainings = (server) => {
      if (server.user_name!== "") {
        setSelectedServer(server);
        setShowAssignModal(true);
      } else {
        openServerDetails(server);
      }
    };

    const closeAllModals = () => {
      setShowServerModal(false);
      setShowAssignModal(false);
      setSelectedServer(null);
    };

    const toggleAddServer = () => {
      setAddServerOpen(!addServerOpen);
    };

    const openDeleteModal = (server) => {
      setServerToDelete(server);
      setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
      setShowDeleteModal(false);
      setServerToDelete(null);
    };

    const controllerRef = useRef(null);
    const fetchServers = async () => {
      setLoading(true);
      // cancel previous request
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      const controller = new AbortController();
      controllerRef.current = controller;
      try {        
        const res = await postDataAPI({
          serviceName: "server_data",
          op: "server_coaching_outlet_server_list",
          is_show_all: true,
          load: 1,
          fromList: true
        }, controller.signal);

        if (res.status === "ok") {
          setServers(res.data.server_data || []);
        }
       
      } catch (err) {
        if (err.code === "ERR_CANCELED") {
          console.log("Request cancelled");
          return;
        }
        console.error(err);
      } finally {
        setLoading(false);
      }
    };


    useEffect(() => {
      fetchServers();
      return () => {
        if (controllerRef.current) {
          controllerRef.current.abort();
        }
      };
    }, []);

    const updateSingleServer = (serverId, updatedData) => {
      setServers((prev) =>
        prev.map((s) => (s.server_id === serverId ? { ...s, ...updatedData } : s))
      );
      setSelectedServer((prev) =>
        prev && prev.server_id === serverId ? { ...prev, ...updatedData } : prev
      );
    };

    const generateAccessCode = () => {
      return Math.random().toString(36).substring(2, 10).toUpperCase();
    };

    const handleDeleteServer = async () => {
      if (!serverToDelete) return;

      try {
        await postDataAPI({
          serviceName: "server_data",
          op: "server_coaching_delete_server",
          server_id: serverToDelete.server_id
        });
        closeDeleteModal();
        await fetchServers();
      } catch (err) {
        alert("Failed to delete server");
      }
    };


    const handleCreateServer = () => {
      if (!serverForm.username || !serverForm.access_code) {
        alert("Username and Access Code are required");
        return;
      }

      setSaving(true);

      postDataAPI({
        serviceName: "server_data",
        op: "server_coaching_save_server",
        server_first_name: serverForm.first_name,
        server_last_name: serverForm.last_name,
        server_user_name: serverForm.username,
        access_code: serverForm.access_code
      })
        .then((res) => {
          if (res.status === "ok") {
            toggleAddServer();
            fetchServers();

            // reset form
            setServerForm({
              first_name: "",
              last_name: "",
              username: "",
              access_code: ""
            });
          } else {
            alert(res.message || "Failed to create server");
          }
        })
        .finally(() => setSaving(false));
    };

    const TRAINING_LOGIN_URL = process.env.REACT_APP_TRAINING_LOGIN_URL;

const handleCopyCredentials = async (row) => {
  const textToCopy = `
Login URL: ${TRAINING_LOGIN_URL}
Username: ${row.user_name}
Access Code: ${row.access_code}
  `.trim();

  try {
    await navigator.clipboard.writeText(textToCopy);

    console.log("Credentials copied!");

    // ✅ CALL API TO HIDE PASSWORD
    await postDataAPI({
      serviceName: "server_data",
      op: "hide_server_password",
      server_id: row.server_id
    });

    // ✅ Update UI instantly (no need full refresh)
    setServers(prev =>
      prev.map(s =>
        s.server_id === row.server_id
          ? { ...s, copied_password: 1, access_code: "" }
          : s
      )
    );

  } catch (err) {
    console.error("Copy failed", err);
  }
};

  const handleInactiveServer = async (server, flag) => {
    try {
      const res = await postDataAPI({
        serviceName: "server_data",
        op: "inactive_server",
        server_id: server.server_id,
        server_active_inactive: flag
      });

      if (res.status === "ok") {
        await fetchServers(); // loader handled inside
      } else {
        alert(res.message || "Failed to inactive server");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const openBulkCredModal = () => {
    setShowBulkCredModal(true);
  };

  const closeBulkCredModal = () => {
    setShowBulkCredModal(false);
  };

  const handleBulkGenerateCredentials = async () => {
    try {
      setBulkLoading(true);

      const res = await postDataAPI({
        serviceName: "server_data",
        op: "bulk_assign_server_credentials"
      });

      if (res.status === "ok") {
        await fetchServers();
        closeBulkCredModal();
      } else {
        alert(res.message || "Failed to generate credentials");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    } finally {
      setBulkLoading(false);
    }
  };

  const filteredServers = servers.filter((s) => {
    return s.status === statusFilter;
  });


  const handleOpenTrainingUrl = () => {
    if (TRAINING_LOGIN_URL) {
      window.open(TRAINING_LOGIN_URL, "_blank"); // opens in new tab
    } else {
      alert("Training URL not configured");
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        {/* Header */}
        <Row className="align-items-center mb-4">
          <Col>
            <h4 className="fw-bold mb-1">
              <i className="ri-user-settings-line me-2"></i>
              Server Management
            </h4>
            <p className="text-muted mb-0">
              Manage your servers and assign training materials
            </p>
          </Col>
          <Col className="text-end">
          <Button outline  className="me-2"
                onClick={() => history.push("/server-performance-coaching")}
            >
                ⬅ Back to Home
            </Button>
            <Button
              color="secondary"
              onClick={openBulkCredModal}
              className="me-2"
            >
              <i className="ri-lock-password-line me-1"></i>
              Generate Credentials
            </Button>
            <Button color="primary" onClick={toggleAddServer}>
              <i className="ri-user-add-line me-1"></i>
              Add Server
            </Button>
          </Col>
        </Row>

        {/* Card */}
        <Card>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-bold mb-0">
                Servers ({filteredServers.length})
              </h6>

              <div className="d-flex gap-2">
                {/* <Button
                  size="sm"
                  color={statusFilter === "" ? "secondary" : "secondary"}
                  outline={statusFilter !== ""}
                  onClick={() => setStatusFilter("")}
                >
                  All
                </Button> */}
                <Button color="info" onClick={() => setShowQrModal(true)} className="me-2 text-white d-inline-flex align-items-center gap-1">
                  <i className="ri-qr-code-line"></i> Training Login QR Code
                </Button>
                <Button color="primary" onClick={handleOpenTrainingUrl} className="me-2">
                  Training Login URL
                </Button>
                <Button
                  size="sm"
                  color={statusFilter === "Active" ? "secondary" : "secondary"}
                  outline={statusFilter !== "Active"}
                  onClick={() => setStatusFilter("Active")}
                >
                  Active
                </Button>
      
                <Button
                  size="sm"
                  color={statusFilter === "Inactive" ? "secondary" : "secondary"}
                  outline={statusFilter !== "Inactive"}
                  onClick={() => setStatusFilter("Inactive")}
                >
                  Inactive
                </Button>
              </div>
            </div>
            {loading && <Loader />}
            <div className={loading ? "opacity-0 " : "table-responsive"}>
              <Table className="align-middle mb-0" bordered>
                <thead className="table-light">
                  <tr>
                    <th>Name</th>
                    <th>Username</th>
                    <th>Training Progress</th>
                    <th>Quiz Score</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredServers.length === 0 && !loading && (
                    <tr>
                      <td colSpan="7" className="text-center text-muted py-4">
                        No servers found
                      </td>
                    </tr>
                  )}

                  {filteredServers.map((server) => {
                    const completed = server?.quiz_data.length || 0;
                    const total = server?.flash_cards.length || 0;

                    const quizData = server?.quiz_data || [];

                    const totalScore = quizData.reduce(
                      (sum, q) => sum + Number(q.score || 0),
                      0
                    );

                    const totalQuestions = quizData.reduce(
                      (sum, q) => sum + Number(q.total_questions || 0),
                      0
                    );

                    const quizPercentage =
                      totalQuestions > 0
                        ? Math.round((totalScore / totalQuestions) * 100)
                        : null;

                    const quizScore =
                      quizPercentage !== null ? `${quizPercentage}%` : "No quizzes";

                    const quizStatus =
                      quizPercentage >= 50
                        ? "success"
                        : quizPercentage !== null
                          ? "danger"
                          : "secondary";

                    return (
                      <tr key={server.id}>
                        <td className="fw-medium">{server.name}</td>

                        {/* <td>{server.email || "-"}</td> */}
                        <td>{server.user_name || "-"}</td>

                        <td>
                          <Badge color="success" pill>
                            {completed}/{total} completed
                          </Badge>
                        </td>

                        <td>
                          <Badge color={quizStatus} pill>
                            {quizScore}
                          </Badge>
                        </td>

                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-2">
                            <Button
                              size="sm"
                              outline
                              color="secondary"
                              onClick={() => openServerDetails(server)}
                            >
                              <i className="ri-eye-line me-1"></i> View
                            </Button>

                            <Button
                              size="sm"
                              outline
                              color="secondary"
                              onClick={() => handleCopyCredentials(server)}
                              title="Copy Credentials, Once copied Access Code hide"
                              disabled={!server?.user_name || Number(server?.copied_password) === 1}
                            >
                              <i className="ri-clipboard-line"></i>
                            </Button>
                           <Button
                            size="sm"
                            outline
                            color="primary"
                            onClick={() => openAssignTrainings(server)}
                          >
                            Assign Trainings
                          </Button>
                          {server?.status === "Active" && (
                            <Button
                              size="sm"
                              outline
                              color="warning"
                              onClick={() => handleInactiveServer(server,0)}
                              title="Make Inactive"
                            >
                              Inactive
                            </Button>
                          )}
                          {server?.status === "Inactive" && (
                            <Button
                              size="sm"
                              outline
                              color="success"
                              onClick={() => handleInactiveServer(server,1)}
                              title="Make Active"
                            >
                              
                              Active
                            </Button>
                          )}


                            <Button
                              size="sm"
                              outline
                              color="danger"
                              onClick={() => openDeleteModal(server)}
                            >
                              <i className="ri-delete-bin-line"></i>
                            </Button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>

              </Table>
            </div>
          </CardBody>
        </Card>

        <Modal isOpen={addServerOpen} toggle={toggleAddServer} centered>
          <ModalHeader toggle={toggleAddServer}>
            Add New Server
            <div className="small text-muted">
              Create a new server account with login credentials
            </div>
          </ModalHeader>

          <ModalBody>
            <Row className="gy-3">
              <Col md={6}>
                <Label>First Name</Label>
                <Input
                  placeholder="John"
                  value={serverForm.first_name}
                  onChange={(e) =>
                    setServerForm({ ...serverForm, first_name: e.target.value })
                  }
                />
              </Col>

              <Col md={6}>
                <Label>Last Name</Label>
                <Input
                  placeholder="Doe"
                  value={serverForm.last_name}
                  onChange={(e) =>
                    setServerForm({ ...serverForm, last_name: e.target.value })
                  }
                />
              </Col>

              <Col md={12}>
                <Label>Username</Label>
                <Input
                  placeholder="johndoe"
                  value={serverForm.username}
                  onChange={(e) =>
                    setServerForm({ ...serverForm, username: e.target.value })
                  }
                />
              </Col>

              <Col md={12}>
                <Label>Access Code</Label>
                <div className="d-flex gap-2">
                  <Input
                    placeholder="Enter or generate access code"
                    value={serverForm.access_code}
                    onChange={(e) =>
                      setServerForm({ ...serverForm, access_code: e.target.value })
                    }
                  />
                  <Button
                    outline
                    color="secondary"
                    onClick={() =>
                      setServerForm({
                        ...serverForm,
                        access_code: generateAccessCode()
                      })
                    }
                  >
                    <i className="ri-refresh-line"></i>
                  </Button>
                </div>
              </Col>

            </Row>
          </ModalBody>

          <ModalFooter>
            <Button outline onClick={toggleAddServer}>
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={handleCreateServer}
              disabled={saving}
            >
              {saving ? "Creating..." : "Create Server"}
            </Button>

          </ModalFooter>
        </Modal>

        {/* <ServerDetailsModal
          isOpen={showServerModal}
          toggle={closeAllModals}
          server={selectedServer}
          onManageFlashcards={() => {
            //setShowServerModal(false);
            setShowAssignModal(true);
          }}
        /> */}
        <ServerDetailsModal
          isOpen={showServerModal}
          toggle={closeAllModals}
          server={selectedServer}
          fetchServers={fetchServers}
          onManageFlashcards={() => setShowAssignModal(true)}
        />

        <BulkCredentialModal
          isOpen={showBulkCredModal}
          toggle={closeBulkCredModal}
          onConfirm={handleBulkGenerateCredentials}
          loading={bulkLoading}
        />


        <AssignTrainingsModal
          isOpen={showAssignModal}
          toggle={closeAllModals}
          server={selectedServer}
          updateSingleServer={updateSingleServer}
        />

        <DeleteServerModal
          isOpen={showDeleteModal}
          toggle={closeDeleteModal}
          server={serverToDelete}
          onConfirm={handleDeleteServer}
        />
        <QrCodeModal
          isOpen={showQrModal}
          toggle={() => setShowQrModal(!showQrModal)}
          url={TRAINING_LOGIN_URL}
        />
        <ToastContainer />
      </Container>
    </div>
  );
};


const DeleteServerModal = ({ isOpen, toggle, server, onConfirm }) => {
  if (!server) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>
        Delete Server
      </ModalHeader>

      <ModalBody>
        <p className="text-muted mb-0">
          Are you sure you want to delete{" "}
          <strong>{server.name}</strong>? This will also remove all
          their training assignments. This action cannot be undone.
        </p>
      </ModalBody>

      <ModalFooter>
        <Button outline onClick={toggle}>
          Cancel
        </Button>
        <Button color="danger" onClick={onConfirm}>
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const BulkCredentialModal = ({ isOpen, toggle, onConfirm, loading }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>
        Generate Credentials
      </ModalHeader>

      <ModalBody>
        <p className="text-muted mb-0">
          This will generate credentials only for servers whose credentials are
          not generated yet.
          <br /><br />
          Already generated credentials will not be affected.
        </p>
      </ModalBody>

      <ModalFooter>
        <Button outline onClick={toggle} disabled={loading}>
          Cancel
        </Button>

        <Button
          color="primary"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Generating..." : "Confirm"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const QrCodeModal = ({ isOpen, toggle, url }) => {
  const qrRef = useRef(null);

  const handleDownload = () => {
    try {
      const svg = qrRef.current.querySelector("svg");
      if (!svg) return;
      
      const svgData = new XMLSerializer().serializeToString(svg);
      const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
      const SVG_URL = URL.createObjectURL(svgBlob);
      
      const image = new Image();
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = 512;
        canvas.height = 512;
        const context = canvas.getContext("2d");
        
        // draw background
        context.fillStyle = "#ffffff";
        context.fillRect(0, 0, 512, 512);
        
        context.drawImage(image, 0, 0, 512, 512);
        
        const pngUrl = canvas.toDataURL("image/png");
        const downloadLink = document.createElement("a");
        downloadLink.download = "training-login-qr.png";
        downloadLink.href = pngUrl;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        
        URL.revokeObjectURL(SVG_URL);
      };
      image.src = SVG_URL;
    } catch (err) {
      console.error("Download failed", err);
      toast.error("Failed to download QR code");
    }
  };

  const handleShareQr = async () => {
    try {
      const svg = qrRef.current.querySelector("svg");
      if (!svg) return;

      const svgData = new XMLSerializer().serializeToString(svg);
      const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
      const SVG_URL = URL.createObjectURL(svgBlob);

      const image = new Image();
      image.onload = async () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = 512;
          canvas.height = 512;
          const context = canvas.getContext("2d");
          
          context.fillStyle = "#ffffff";
          context.fillRect(0, 0, 512, 512);
          context.drawImage(image, 0, 0, 512, 512);
          
          URL.revokeObjectURL(SVG_URL);
          
          canvas.toBlob(async (blob) => {
            if (!blob) return;
            const file = new File([blob], "training-login-qr.png", { type: "image/png" });
            
            if (navigator.canShare && navigator.canShare({ files: [file] })) {
              try {
                await navigator.share({
                  files: [file],
                  title: "Training Login QR Code",
                  text: "Scan this QR code to login to your training account."
                });
                return;
              } catch (shareErr) {
                if (shareErr.name === "AbortError") return;
                console.error("Web Share failed", shareErr);
              }
            }
            
            if (navigator.clipboard && window.ClipboardItem) {
              try {
                await navigator.clipboard.write([
                  new window.ClipboardItem({ [blob.type]: blob })
                ]);
                toast.success("QR Code image copied to clipboard!", { position: "top-right", hideProgressBar: true });
                return;
              } catch (clipErr) {
                console.error("Clipboard copy failed", clipErr);
              }
            }
            
            toast.info("Image copy/share not fully supported on this browser. Please use the Download button.", { position: "top-right", hideProgressBar: true });
          }, "image/png");
        } catch (err) {
          console.error("Error drawing image to canvas", err);
          toast.error("Failed to prepare QR code for sharing");
        }
      };
      image.src = SVG_URL;
    } catch (err) {
      console.error("Share failed", err);
      toast.error("Failed to share QR code");
    }
  };

  const handleShareUrl = async () => {
    const shareText = `Log in to your training account using this link: ${url}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Training Login URL",
          text: "Log in to your training account using this link:",
          url: url
        });
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Error sharing URL", err);
        }
      }
    } else {
      try {
        await navigator.clipboard.writeText(shareText);
        toast.success("Training Login URL and message copied to clipboard!", { position: "top-right", hideProgressBar: true });
      } catch (err) {
        console.error("Failed to copy URL", err);
        toast.error("Failed to copy URL to clipboard");
      }
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle} className="border-bottom-0 pb-0">
        <div className="d-flex align-items-center">
          <i className="ri-qr-code-line text-primary fs-2 me-2"></i>
          <div>
            <h5 className="modal-title fw-bold">Training Login QR Code</h5>
            <span className="text-muted small">Scan or download this QR code</span>
          </div>
        </div>
      </ModalHeader>
      <ModalBody className="text-center py-4">
        <div 
          ref={qrRef}
          className="p-4 mx-auto mb-4 bg-white rounded-3 shadow-sm border"
          style={{ width: "240px", height: "240px", display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          {url ? (
            <QRCode
              value={url}
              size={180}
              level="H"
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            />
          ) : (
            <span className="text-muted">No URL available</span>
          )}
        </div>        

        <div className="d-flex flex-column flex-sm-row justify-content-center gap-2 px-3">
          <Button color="primary" onClick={handleDownload} className="d-flex align-items-center justify-content-center">
            <i className="ri-download-2-line me-1"></i> Download QR
          </Button>
          {/* <Button color="info" onClick={handleShareQr} className="d-flex align-items-center justify-content-center text-white">
            <i className="ri-share-line me-1"></i> Share QR
          </Button>
          <Button color="success" onClick={handleShareUrl} className="d-flex align-items-center justify-content-center">
            <i className="ri-link me-1"></i> Share URL
          </Button> */}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ServerManagement;
